import { createApi } from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'
import { User } from '../../types'

export type GetUsersQueryPaylod = {}

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: baseQueryConfigured,
  tagTypes: ['Users'],
  endpoints: (builder) => ({
    editUser: builder.mutation({
      query: (payload: User) => {
        return {
          url: `${CONSTANTS.API.USERS}/${payload.id}`,
          method: 'PATCH',
          body: payload,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
    }),
  }),
})

const generateUrl = (queryParams: GetUsersQueryPaylod) => {
  let query = new URLSearchParams(queryParams).toString()
  query = query.replace('undefined', '')
  return `${CONSTANTS.API.USERS}${query.length > 0 ? '?' : ''}${query}`
}

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useEditUserMutation } = usersApi
